import { Line } from "@visx/shape";

type ConcurrencyChartReferenceLineProps = {
  xMax: number;
  y: number;
  color: string;
  fromX?: number;
  toX?: number;
  strokeWidth?: number;
  strokeDasharray?: string;
  opacity?: number;
};

const ConcurrencyChartReferenceLine = ({
  xMax,
  y,
  color,
  fromX = 0,
  toX,
  strokeWidth = 1,
  strokeDasharray,
  opacity = 1,
}: ConcurrencyChartReferenceLineProps) => (
  <Line
    from={{ x: fromX, y }}
    to={{ x: toX ?? xMax, y }}
    stroke={color}
    strokeWidth={strokeWidth}
    strokeDasharray={strokeDasharray}
    opacity={opacity}
    pointerEvents="none"
  />
);

ConcurrencyChartReferenceLine.displayName = "UsageWorkers.ConcurrencyChart.ReferenceLine";

export default ConcurrencyChartReferenceLine;
